export const BLOCK_TYPE = {
  PHOTO: 'photo',
  NAV: 'nav'
}

export const JUMP_TYPE = {
  PRODUCT: 'product',
  ACTIVITY: 'activity',
  GIFT_CARD: 'giftCard',
  FAMILY_MP_DETAIL: 'familyMpDetail',
  MAN_TU_MP_DETAIL: 'manTuMpDetail',
  HIMO_MP_DETAIL: 'himoMpDetail',
  RETAIL_MP_DETAIL: 'retailMpDetail'
}

export const JUMP_BRAND = {
  BLUE: 'himo_blue',
  GOLD: 'himo_gold',
  FAMILY: 'himo_family',
  MAN_TU: 'mainto_photography',
  TIAN_SHENG: 'tian_sheng'
}

export const NAV_TYPE = {
  LEFT_RIGHT: 'leftRight',
  TOP_DOWN: 'topDown'
}

export const EMPTY_TYPE = {
  OFFLINE: 'offline',
  WAIT: 'wait'
}


export const ENV_TYPE = {
  H5: 'h5',
  WX_MP: 'wx',
  TT_MP: 'tt',
  ALI_MP: 'alipay',
  APP: 'app'
}
